import type { ConstValues } from '@openx/types/helpers.ts';

export const SupplementalAdQualityField = {
  INDUSTRIES_OP: 'brand_labels.op',
  INDUSTRIES_IDS: 'brand_labels.ids',
  BRANDS_OP: 'brands.op',
  BRANDS_IDS: 'brands.ids',
  CONTENT_ATRIBUTES_OP: 'content_attributes.op',
  CONTENT_ATRIBUTES_IDS: 'content_attributes.ids',
  CREATIVE_TYPES_OP: 'creative_types.op',
  CREATIVE_TYPES_IDS: 'creative_types.ids',
  LANGUAGES_OP: 'languages.op',
  LANGUAGES_IDS: 'languages.ids',
  REQUEST_LIMIT: 'lean_filters.disable_total_requests_filter',
  FILE_WEIGHT: 'lean_filters.disable_pixel_buckets',
  UNBRANDED_RTB: 'allow_unbranded_rtb_bids',
} as const;
export type SupplementalAdQualityField = ConstValues<typeof SupplementalAdQualityField>;

export const DEAL_SUPPLEMENTS = 'deal_supplements';

export const Filters = {
  CURRENT: 'current',
  ALLOW: 'allow',
  ALLOW_ALL: 'allow_all',
} as const;
export type Filters = ConstValues<typeof Filters>;

export function getFilterOptions(t) {
  return {
    [Filters.CURRENT]: { id: Filters.CURRENT, name: t('Use current filter') },
    [Filters.ALLOW]: { id: Filters.ALLOW, name: t('Allow these') },
    [Filters.ALLOW_ALL]: { id: Filters.ALLOW_ALL, name: t('Allow all') },
  };
}

export function getLeanFilters(t) {
  return {
    '0': { id: '0', name: t('Use current filter') },
    '1': { id: '1', name: t('Allow all') },
  };
}
interface SupplementalAdQualityFilterForm {
  op: Filters;
  /** Plain array — RHF clones `defaultValues`; `Set` is not reliably preserved across versions. */
  ids: string[];
}

export interface SupplementalAdQualityFormState {
  allow_unbranded_rtb_bids: boolean;
  lean_filters: {
    disable_total_requests_filter: '0' | '1';
    disable_pixel_buckets: '0' | '1';
  };
  brand_labels: SupplementalAdQualityFilterForm;
  brands: SupplementalAdQualityFilterForm;
  content_attributes: SupplementalAdQualityFilterForm;
  creative_types: SupplementalAdQualityFilterForm;
  languages: SupplementalAdQualityFilterForm;
}
